import React, { useState, useEffect, useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { crd, bdg, sp, rad, type, icBox, listRow } from "../../constants/styles";
import Ic from "../common/Ic";

export default function AdminTenants() {
  const { h, go } = useContext(Ctx);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const params = {};
      if (search) params.search = search;
      const res = await api.adminGetTenants(params);
      if (res.success) setItems(res.tenants || []);
      setLoading(false);
    };
    const timer = setTimeout(load, search ? 400 : 0);
    return () => clearTimeout(timer);
  }, [search]);

  return <div style={{ paddingTop: sp.lg }} className="animate-fadeIn">
    <button onClick={() => go("dash")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", ...type.sm, marginBottom: sp.md, display: "flex", alignItems: "center", gap: sp.xs }}>
      <Ic n="arrow-left" s={14} c={h.ac} /> Dashboard
    </button>

    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: sp.lg }}>
      <h2 style={{ ...type.h2, color: h.tx, margin: 0 }}>All Tenants</h2>
      <span style={{ ...type.xs, color: h.ts }}>{items.length} found</span>
    </div>

    {/* Search */}
    <div style={{ position: "relative", marginBottom: sp.lg }}>
      <Ic n="search" s={16} c={h.tt} />
      <input value={search} onChange={e => setSearch(e.target.value)}
        placeholder="Search name or phone..."
        style={{ width: "100%", padding: `${sp.sm}px ${sp.md}px`, paddingLeft: 36, borderRadius: rad.md, border: `1px solid ${h.bd}`, background: h.ib, color: h.tx, ...type.sm, outline: "none", boxSizing: "border-box" }}
      />
    </div>

    {loading ? (
      <div style={{ textAlign: "center", padding: sp.xxxl }}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={h.ac} strokeWidth="2" style={{ animation: "spin 1s linear infinite" }}><path d="M21 12a9 9 0 11-6.219-8.56" /></svg>
      </div>
    ) : items.length === 0 ? (
      <div style={{ ...crd(h), textAlign: "center", padding: sp.xxxl }}>
        <Ic n="users" s={28} c={h.tt} />
        <div style={{ ...type.sm, color: h.tt, marginTop: sp.sm }}>No tenants found</div>
      </div>
    ) : (
      <div style={{ ...crd(h), padding: 0, overflow: "hidden" }}>
        {items.map((t, i) => (
          <div key={t.id} style={listRow(h, i === items.length - 1)}>
            <div style={{ display: "flex", alignItems: "center", gap: sp.md, flex: 1, minWidth: 0 }}>
              <div style={icBox(h.ac, 36)}>
                <Ic n="user" s={16} c={h.ac} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ ...type.sm, color: h.tx, fontWeight: 600 }}>{t.name}</div>
                <div style={{ ...type.xs, color: h.tt }}>
                  {t.phone} {t.org_name ? `\u00B7 ${t.org_name}` : ""}
                </div>
                {t.property_name && <div style={{ ...type.xs, color: h.ts }}>{t.property_name}</div>}
              </div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>;
}
